import { useAuthContext } from "@/auth/context/auth.hook";
import { clearCredentials } from "@/auth/lib";
import { useCallback, useState } from "react";

interface Options {
  onSuccess?: () => void;
  onError?: (message: string) => void;
}

export function useSignOut({ onSuccess, onError }: Options = {}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>();
  const { setSessionUser } = useAuthContext();

  const signOut = useCallback(() => {
    setLoading(true);
    clearCredentials()
      .then(() => {
        setSessionUser(undefined);

        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((e: Error) => {
        setError(e.message);
        if (onError) {
          onError(e.message);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [setSessionUser, onSuccess, onError]);

  return { signOut, loading, error };
}
